import React from 'react';
import { Box, AppBar, Toolbar, Typography, Button, Container } from '@mui/material';
import { Link, useNavigate } from 'react-router-dom';
import { useTenant } from '../../context/TenantContext';

interface PublicLayoutProps {
  children: React.ReactNode;
}

export const PublicLayout: React.FC<PublicLayoutProps> = ({ children }) => {
  const { currentTenant } = useTenant();
  const navigate = useNavigate();

  const handleAdminLogin = () => {
    navigate('/admin/login');
  };

  // Get header colors from theme, with defaults
  const headerBgColor = currentTenant?.theme?.headerBackgroundColor || '#1976d2';
  const headerTextColor = currentTenant?.theme?.headerTextColor || '#ffffff';

  return (
    <Box sx={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
      <AppBar
        position="static"
        sx={{
          boxShadow: 1,
          backgroundColor: headerBgColor,
          color: headerTextColor
        }}
      >
        <Toolbar>
          <Box sx={{ display: 'flex', alignItems: 'center', flexGrow: 1 }}>
            {currentTenant?.theme.logoUrl && (
              <img
                src={currentTenant.theme.logoUrl}
                alt={`${currentTenant.name} logo`}
                style={{ height: 40, marginRight: 16 }}
              />
            )}
            <Typography variant="h6" component={Link} to="/" sx={{
              textDecoration: 'none',
              color: headerTextColor,
              fontWeight: 600
            }}>
              {currentTenant?.name || 'HR Portal'}
            </Typography>
          </Box>

          <Box sx={{ display: 'flex', gap: 2 }}>
            <Button
              sx={{
                textTransform: 'none',
                color: headerTextColor,
                '&:hover': {
                  backgroundColor: 'rgba(255,255,255,0.1)'
                }
              }}
              component={Link}
              to="/jobs"
            >
              Jobs
            </Button>
            <Button
              sx={{
                textTransform: 'none',
                color: headerTextColor,
                '&:hover': {
                  backgroundColor: 'rgba(255,255,255,0.1)'
                }
              }}
              onClick={handleAdminLogin}
            >
              Admin
            </Button>
          </Box>
        </Toolbar>
      </AppBar>

      <Box component="main" sx={{ flexGrow: 1 }}>
        {children}
      </Box>

      <Box
        component="footer"
        sx={{
          py: 3,
          px: 2,
          backgroundColor: 'grey.100',
          borderTop: 1,
          borderColor: 'grey.300'
        }}
      >
        <Container maxWidth="lg">
          <Typography variant="body2" color="text.secondary" align="center">
            © 2024 {currentTenant?.name || 'HR Portal'}. All rights reserved.
          </Typography>
        </Container>
      </Box>
    </Box>
  );
};